import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getKioskOptions } from '../../../selectors/ui';
import Translation from "../../../../shared/Translation";

class KioskConfirmationContainer extends Component {

    isDeliveryEmail() {
        let deliveryType = "Online";
        return this.checkDeliveryTypeMatches(deliveryType);
    }

    isDeliveryMobile() {
        let deliveryType = "Mobile";
        return this.checkDeliveryTypeMatches(deliveryType);
    }

    checkDeliveryTypeMatches(deliveryType) {
        let deliveryOptions = Object.values(this.props.deliveryOptions);
        for (let i = 0; i < deliveryOptions.length; i++) {
            if (deliveryOptions[i].id == this.props.reservationSelectedDelivery) {
                if (deliveryOptions[i].method_name == deliveryType) {
                    return true;
                }
            }
        }
        return false;
    }

    render() {
        return(
            <div className="kiosk-confirmation">
                {(this.props.kioskOptions.printReceipts) &&
                    <span className="kiosk-confirmation__text"><Translation>{"checkout__kiosk_take_receipt"}</Translation></span>
                }

                {(this.props.kioskOptions.printReceiptsAndTickets) &&
                    <span className="kiosk-confirmation__text"><Translation>{"checkout__kiosk_take_tickets"}</Translation></span>
                }

                {(this.props.kioskOptions.allowEmailDelivery && this.isDeliveryEmail()) &&
                    <span className="kiosk-confirmation__text"><Translation>{"checkout__kiosk_tickets_emailed"}</Translation></span>
                }

                {(this.props.kioskOptions.allowMobileDelivery && this.isDeliveryMobile()) &&
                    <span className="kiosk-confirmation__text"><Translation>{"checkout__kiosk_tickets_phone"}</Translation></span>
                }
            </div>
        )
    }
}

const mapStateToProps = (state, props) => {
    return {
        kioskOptions: getKioskOptions(state),
        deliveryOptions: state.delivery.options,
        reservationSelectedDelivery: state.reservation.selected_delivery_option,
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
    }, dispatch);
}

KioskConfirmationContainer.propTypes = {
}

export default connect(mapStateToProps, mapDispatchToProps)(KioskConfirmationContainer)
